import axios from 'axios'

const Axios = axios.create({
    baseURL: 'https://www.bawayft.com/ft/',
   //  baseURL: 'http://47.93.236.33:9800/',
    timeout: 60000,
    responseType: "json",
    withCredentials: false
});

//发送请求前进行拦截
Axios.interceptors.request.use((config) => {
    // Loading.service({text: "加载中...请稍候..."});
    // config.headers["Language"] = localStorage.getItem('locale') || 'cn';
    // config.headers["Token"] = getToken();
    config.headers = {
        Language: localStorage.getItem('lang') || 'zh',
    }
    let chnEn = 1;
    if (localStorage.getItem('lang') && localStorage.getItem('lang') === 'en') {
        chnEn = 2;
    } else {
        chnEn = 1;
    }
    if (config.method === 'get') {
        config.params = {
            chnEn,
            userId: 1,
            t: new Date().getTime(),
            ...config.params
        }
    }
    return config;
}, (error) => {
    return Promise.reject(error)
})
//请求响应后拦截
Axios.interceptors.response.use((res) => {
    if (res.status === 200) {
        return Promise.resolve(res.data)
    }
}, (error) => {
    return Promise.reject(error)
})
export default Axios
